import React, { memo, useState } from "react";
import { ADMIN_LANG } from "../../../settings";
import { SelectData } from "../../../types/admin";
import { Col, Table, Collapse } from "react-bootstrap";
import {Eye} from "react-bootstrap-icons";

const SelectTableRow = memo(({ option, onToggle, maxPoints = 0 }: { option: SelectData, onToggle: () => void, maxPoints?: number }) => {
    const pointColor = option.points > 0 ? 'text-success' : (option.points < 0 ? 'text-danger' : 'text-muted');

    return (
        <>
            <tr onClick={onToggle} style={{ cursor: 'pointer' }}>
                <td>{option.name} {option.open_answers.length > 0 ?
                <span className='modal-link ms-3'><Eye/></span> : ''}</td>
                {maxPoints > 0 &&
                    <td className={`text-center ${pointColor}`}>{option.points}</td>
                }
                <td className="text-center">{option.selections}</td>
            </tr>
            {option.open_answers.length > 0 && (
            <tr>
                <td colSpan={3} className="p-0">
                    <Collapse in={option.isOpen}>
                        <div>
                            <ul style={{'marginBottom': 0}} className="py-2">
                                {option.open_answers.map((answer, index) => (
                                    <li key={index}>{answer}</li>
                                ))}
                            </ul>
                        </div>
                    </Collapse>
                </td>
            </tr>
            )}
        </>
    );
});

const SelectTable = ({ optionsData, maxPoints = 0 }: { optionsData: SelectData[], maxPoints?:number }) => {
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

    const toggleRow = (index: number) => {
        setExpandedRows(prev => {
            const newRows = new Set(prev);
            if (newRows.has(index)) {
                newRows.delete(index);
            } else {
                newRows.add(index);
            }
            return newRows;
        });
    };

    return (
        <Col xs={12} lg={6}>
            <div className="admin-card">
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>{ADMIN_LANG.name}</th>
                            {maxPoints > 0 &&
                                <th className="text-center">{ADMIN_LANG.points}</th>
                            }
                            <th className="text-center">{ADMIN_LANG.selections}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {optionsData.map((option, index) => (
                            <SelectTableRow
                                key={index}
                                option={{ ...option, isOpen: expandedRows.has(index) }}
                                onToggle={() => toggleRow(index)}
                                maxPoints={maxPoints}
                            />
                        ))}
                    </tbody>
                </Table>
            </div>
        </Col>
    );
};

export default memo(SelectTable);